import React, { FC } from "react";

import { IRole } from "@/data/roles";
import { FloatedList } from "@/eworkitComponents";

import { SuggestedRoleBadge } from "./SuggestedRoleBadge";

interface ISuggestedRolesListProps {
  onClick: (role: IRole) => void;
  onCheckedClick: (role: IRole) => void;
  suggestedRoles: IRole[];
  selectedRoles?: IRole[];
}

export const SuggestedRolesList: FC<ISuggestedRolesListProps> = ({
  onClick,
  onCheckedClick,
  selectedRoles,
  suggestedRoles,
}) => {
  return (
    <FloatedList>
      {suggestedRoles.map(role => (
        <SuggestedRoleBadge
          key={role.id}
          role={role}
          onClick={() => onClick(role)}
          onCheckedClick={() => onCheckedClick(role)}
          isChecked={selectedRoles?.some(r => r?.id === role?.id)}
        />
      ))}
    </FloatedList>
  );
};
